<div class="customization-style">

    <mat-tab-group #tab (selectedTabChange)="onSelectedTabChange($event)">

        <mat-tab [disabled]="!featuresToggle.eventByGeolocation&&!featuresToggle.manualEvents" label="Event List Style">
            <ng-template mat-tab-label>
                <mat-icon>event</mat-icon>
                Event List Style
                <span>
                    <upgrade-button [show]="!featuresToggle.eventByGeolocation&&!featuresToggle.manualEvents"
                                    [css]="'upgrade-style'"></upgrade-button>
                </span>
            </ng-template>

            <mat-tab-group [class.no-tab-header]="version.event.version==='V2'">
                <mat-tab>
                    <ng-template mat-tab-label>Event List Style</ng-template>

                    <div class="flex">
                        <div class="panel half-width">
                            <div class="panel-header">
                                <h1
                                    [class.text-disabled]="!featuresToggle.eventByGeolocation&&!featuresToggle.manualEvents">
                                    Event List Style</h1>
                                <upgrade-button
                                    [show]="!featuresToggle.eventByGeolocation&&!featuresToggle.manualEvents"
                                    [css]="'upgrade-style'"></upgrade-button>
                            </div>

                            <ng-container *ngIf="!isLoadingCalendarStyle">
                                <mat-radio-group class="radio-group"
                                                 [disabled]="!featuresToggle.eventByGeolocation&&!featuresToggle.manualEvents"
                                                 [(ngModel)]="calendarStyle.event" (ngModelChange)="setCalendarStyle()">
                                    <mat-radio-button [value]="'default'">
                                        Default
                                    </mat-radio-button>
                                    <mat-radio-button [value]="'square'">
                                        Card Style with Square Images
                                    </mat-radio-button>
                                    <mat-radio-button [value]="'long'">
                                        Card Style with Rectangle Images
                                    </mat-radio-button>
                                    <mat-radio-button [value]="'modern-block'">
                                        Card Style with Featured Event / Promotional Image
                                    </mat-radio-button>
                                    <mat-radio-button *ngIf="version.event.version==='V3'" [value]="'fancy'">
                                        (NEW!) Card Style with Rounded Corners & Mouse Over Spotlight
                                    </mat-radio-button>
                                    <mat-radio-button *ngIf="version.event.version==='V3'" [value]="'vertical'">
                                        (NEW!) Vertical Cards Style
                                    </mat-radio-button>
                                </mat-radio-group>

                                <div class="panel-preview half-width">
                                    <p>Preview</p>
                                    <div class="flex" style="gap:8px">
                                        <ng-container *ngIf="calendarStyle.event==='default'">
                                            <div class="preview default" *ngFor="let one of [0,1];let i = index">
                                                <div>
                                                    <img src="{{defaultImg}}" alt="img">
                                                </div>
                                                <div class="time">
                                                    {{ timeSample }}
                                                </div>
                                                <div class="detail">
                                                    <div class="description">Information</div>
                                                    <div #eventbtn class="view">DETAILS</div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="calendarStyle.event==='square'">
                                            <div class="preview square" *ngFor="let one of [0,1];let i = index">
                                                <div imgwrap>
                                                    <img src="{{defaultImg}}" alt="img">
                                                </div>
                                                <div class="time">
                                                    {{ timeSample }}
                                                </div>
                                                <div class="detail-btn">DETAILS</div>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="calendarStyle.event==='long'">
                                            <div class="preview long" *ngFor="let one of [0,1];let i = index">
                                                <div>
                                                    <img src="{{defaultImg}}" alt="img">
                                                </div>
                                                <div class="flex">
                                                    <div class="time">
                                                        {{ timeSample }}
                                                    </div>
                                                    <div class="detail-btn">DETAILS</div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="calendarStyle.event==='modern-block'">
                                            <div class="preview modern-block" *ngFor="let one of [0,1,2];let i = index"
                                                 [ngStyle]="{'flex':i===0?2:1}">
                                                <div class="modern-image">
                                                    <img src="{{defaultImg}}" alt="img">
                                                    <div class="time">
                                                        {{ timeSample }}
                                                    </div>
                                                </div>
                                                <div class="detail">
                                                    <div class="description">Information</div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="calendarStyle.event==='fancy'">
                                            <div class="preview modern-block"
                                                 *ngFor="let one of [0,1,2,3];let i = index"
                                                 [ngStyle]="{'flex':i===1?2:1}" style="border-radius:12px">
                                                <div class="modern-image relative">
                                                    <img src="{{defaultImg}}" alt="img" style="border-radius:12px">
                                                    <div style="position:absolute;bottom:8px;left: 12px;">
                                                        {{ timeSample }}
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="calendarStyle.event==='vertical'">
                                            <div class="preview modern-block"
                                                 *ngFor="let one of [0,1,2,3];let i = index"
                                                 style="padding:24px 8px;border: 1px solid lightgray;">
                                                <div class="modern-image">
                                                    <img src="{{defaultImg}}" alt="img">
                                                </div>
                                                <div
                                                    style="margin-top: 12px;height: 100px;background-color: #f3f2f2;padding:8px">
                                                    <div>Name of the event</div>
                                                    <div>{{ timeSample }}</div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
                            <ig-spinner *ngIf="isLoadingCalendarStyle"></ig-spinner>
                        </div>
                    </div>
                </mat-tab>
                <!-- <mat-tab *ngIf="version.event.version==='V3'">
                    <ng-template mat-tab-label>Event Details Page</ng-template>

                    <div class="panel">
                        <div class="panel-header">
                            <h1>Event Details Style</h1>
                        </div>

                        <ng-container *ngIf="!isLoadingCalendarStyle">
                            <mat-radio-group class="radio-group" [(ngModel)]="calendarStyle.eventDetails"
                                (ngModelChange)="setCalendarStyle()">
                                <mat-radio-button [value]="'default'">
                                    Default - Slide up screen, short description
                                </mat-radio-button>
                                <mat-radio-button [value]="'fancy'">
                                    (New!) Full page, large header image & QR code
                                </mat-radio-button>
                            </mat-radio-group>

                            <div class="panel-preview half-width">
                                <p>Preview</p>

                                <div>
                                    <img *ngIf="calendarStyle.eventDetails==='fancy'"
                                        src="https://iti-images.s3.amazonaws.com/imgs/default-event-details-fancy.jpg"
                                        alt="" width="100%">
                                    <img *ngIf="calendarStyle.eventDetails==='default'" width="100%"
                                        src="https://iti-images.s3.amazonaws.com/imgs/default-event-details.jpg" alt="">
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </mat-tab> -->
            </mat-tab-group>


        </mat-tab>
        <mat-tab [disabled]="!featuresToggle.placeCalendar" label="Place List Style">
            <ng-template mat-tab-label>
                <mat-icon>room</mat-icon>
                Place List Style
                <span>
                    <upgrade-button [show]="!featuresToggle.placeCalendar" [css]="'upgrade-style'"></upgrade-button>
                </span>
            </ng-template>

            <div class="flex">
                <div class="panel half-width">
                    <div class="panel-header">
                        <h1>Place List Style</h1>
                    </div>

                    <ng-container *ngIf="!isLoadingCalendarStyle">
                        <mat-radio-group class="radio-group" [(ngModel)]="calendarStyle.place"
                                         (ngModelChange)="setCalendarStyle()">
                            <mat-radio-button [value]="'default'">
                                Default
                            </mat-radio-button>
                            <mat-radio-button [value]="'square'">
                                Square Image
                            </mat-radio-button>
                            <mat-radio-button [value]="'long'">
                                Long Image
                            </mat-radio-button>
                            <mat-radio-button [value]="'tile'">
                                Modern Tile
                            </mat-radio-button>
                            <mat-radio-button *ngIf="version.place.version==='V3'" [value]="'fancy'">
                                (NEW!) Card Style with Rounded Corners & Mouse Over Spotlight
                            </mat-radio-button>
                            <mat-radio-button *ngIf="version.place.version==='V3'" [value]="'vertical'">
                                (NEW!) Vertical Cards Style
                            </mat-radio-button>
                        </mat-radio-group>

                        <div class="panel-preview half-width">
                            <p>Preview</p>
                            <div class="flex">
                                <ng-container *ngIf="calendarStyle.place==='default'">
                                    <div class="preview default" *ngFor="let one of [0,1];let i = index"
                                         [class.m-r-1]="i===0" [class.m-l-1]="i===1">
                                        <div>
                                            <img src="{{defaultImg}}" alt="img">
                                        </div>
                                        <div class="time">
                                            {{ timeSample }}
                                        </div>
                                        <div class="detail">
                                            <div class="description">Information</div>
                                            <div #eventbtn class="view">DETAILS</div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="calendarStyle.place==='square'">
                                    <div class="preview square" *ngFor="let one of [0,1];let i = index"
                                         [class.m-r-1]="i===0" [class.m-l-1]="i===1">
                                        <div imgwrap>
                                            <img src="{{defaultImg}}" alt="img">
                                        </div>
                                        <div class="time">
                                            {{ timeSample }}
                                        </div>
                                        <div class="detail-btn">DETAILS</div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="calendarStyle.place==='long'">
                                    <div class="preview long" *ngFor="let one of [0,1];let i = index"
                                         [class.m-r-1]="i===0" [class.m-l-1]="i===1">
                                        <div>
                                            <img src="{{defaultImg}}" alt="img">
                                        </div>
                                        <div class="flex">
                                            <div class="time">
                                                {{ timeSample }}
                                            </div>
                                            <div class="detail-btn">DETAILS</div>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="calendarStyle.place==='tile'">
                                    <div class="preview long relative" *ngFor="let one of [0,1,2];let i = index"
                                         [class.m-r-1]="i===0" [class.m-l-1]="i===2" [ngStyle]="{'flex':i===1?2:1}">
                                        <div>
                                            <img src="{{defaultImg}}" alt="img">
                                        </div>
                                        <div
                                            style="position: absolute;left:0;top:20px;background: black;opacity: 0.6;padding:4px">
                                            <div style="color:white">Place Name</div>
                                        </div>
                                        <div class="detail-btn"
                                             style="position: absolute;bottom: 10px; right: 10px;width:60px;">DETAILS
                                        </div>
                                    </div>
                                </ng-container>

                            </div>
                        </div>
                    </ng-container>
                    <ig-spinner *ngIf="isLoadingCalendarStyle"></ig-spinner>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Menu Style">
            <ng-template mat-tab-label>
                <mat-icon>web</mat-icon>
                Menu Style
            </ng-template>

            <div class="flex">
                <div class="panel half-width m-l-1">
                    <div class="panel-header">
                        <h1>Menu Style</h1>
                    </div>

                    <ng-container *ngIf="!isLoadingMenuStyle">
                        <mat-radio-group class="radio-group" [(ngModel)]="isSideBar" (ngModelChange)="setMenuStyle()">
                            <mat-radio-button [value]="true">
                                Sidebar Navigation
                            </mat-radio-button>
                            <mat-radio-button [value]="false">
                                Topbar Navigation
                            </mat-radio-button>
                        </mat-radio-group>

                        <div class="panel-preview">
                            <p>Preview</p>
                            <img *ngIf="isSideBar" src="{{sidebarImage}}" alt="">
                            <img *ngIf="!isSideBar" src="{{topbarImage}}" alt="">
                        </div>
                    </ng-container>

                    <ig-spinner *ngIf="isLoadingMenuStyle"></ig-spinner>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Color">
            <ng-template mat-tab-label>
                <mat-icon>palette</mat-icon>
                Color
            </ng-template>
            <div class="panel">
                <div class="panel-header">
                    <h1>Calendar Color Settings</h1>
                </div>

                <div class="flex color-settings">
                    <div>
                        <b>Filter Button & Card Time</b>
                        <div class="group">
                            <mat-radio-group class="radio-group"
                                             [(ngModel)]="style.eventButton.backgroundColor.isDefault"
                                             (ngModelChange)="toDefault()">
                                <mat-radio-button [value]="true">
                                    Use Default
                                </mat-radio-button>
                                <mat-radio-button [value]="false">
                                    Customize
                                </mat-radio-button>
                                <input [value]="style.eventButton.backgroundColor.value"
                                       [style.background]="style.eventButton.backgroundColor.value"
                                       [cpCancelButton]="true"
                                       [disabled]="style.eventButton.backgroundColor.isDefault"
                                       (colorPickerChange)="chooseColor()"
                                       [(colorPicker)]="style.eventButton.backgroundColor.value"/>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div>
                        <b>Editor's Choice Button</b>
                        <div class="group">
                            <mat-radio-group class="radio-group"
                                             [(ngModel)]="style.placeButton.backgroundColor.isDefault"
                                             (ngModelChange)="toDefault()">
                                <mat-radio-button [value]="true">
                                    Use Default
                                </mat-radio-button>
                                <mat-radio-button [value]="false">
                                    Customize
                                </mat-radio-button>
                                <input [value]="style.placeButton.backgroundColor.value"
                                       [style.background]="style.placeButton.backgroundColor.value"
                                       [cpCancelButton]="true"
                                       [disabled]="style.placeButton.backgroundColor.isDefault"
                                       (colorPickerChange)="chooseColor()"
                                       [(colorPicker)]="style.placeButton.backgroundColor.value"/>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div>
                        <b>Map & Submit Event Buttons</b>
                        <div class="group">
                            <mat-radio-group class="radio-group"
                                             [(ngModel)]="style.defaultButton.backgroundColor.isDefault"
                                             (ngModelChange)="toDefault()">
                                <mat-radio-button [value]="true">
                                    Use Default
                                </mat-radio-button>
                                <mat-radio-button [value]="false">
                                    Customize
                                </mat-radio-button>
                                <input [value]="style.defaultButton.backgroundColor.value"
                                       [style.background]="style.defaultButton.backgroundColor.value"
                                       [cpCancelButton]="true"
                                       [disabled]="style.defaultButton.backgroundColor.isDefault"
                                       (colorPickerChange)="chooseColor()"
                                       [(colorPicker)]="style.defaultButton.backgroundColor.value"/>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div>
                        <b>Pinned Event Borders</b>
                        <div class="group">
                            <mat-radio-group class="radio-group"
                                             [(ngModel)]="style.pinnedEventBorder.borderColor.isDefault"
                                             (ngModelChange)="toDefault()">
                                <mat-radio-button [value]="true">
                                    Use Default
                                </mat-radio-button>
                                <mat-radio-button [value]="false">
                                    Customize
                                </mat-radio-button>
                                <input [value]="style.pinnedEventBorder.borderColor.value"
                                       [style.background]="style.pinnedEventBorder.borderColor.value"
                                       [cpCancelButton]="true"
                                       [disabled]="style.pinnedEventBorder.borderColor.isDefault"
                                       (colorPickerChange)="chooseColor()"
                                       [(colorPicker)]="style.pinnedEventBorder.borderColor.value" cpPosition="left"/>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div>
                        <b>Detail Button</b>
                        <div class="group">
                            <mat-radio-group class="radio-group"
                                             [(ngModel)]="style.detailButton.backgroundColor.isDefault"
                                             (ngModelChange)="toDefault()">
                                <mat-radio-button [value]="true">
                                    Use Default
                                </mat-radio-button>
                                <mat-radio-button [value]="false">
                                    Customize
                                </mat-radio-button>
                                <input [value]="style.detailButton.backgroundColor.value"
                                       [style.background]="style.detailButton.backgroundColor.value"
                                       [cpCancelButton]="true" [disabled]="style.detailButton.backgroundColor.isDefault"
                                       (colorPickerChange)="chooseColor()"
                                       [(colorPicker)]="style.detailButton.backgroundColor.value" cpPosition="left"/>
                            </mat-radio-group>
                        </div>
                    </div>
                    <div>
                        <b>Menu Bar Underline</b>
                        <div class="group">
                            <mat-radio-group class="radio-group" [(ngModel)]="style.sidebarUnderline.color.isDefault"
                                             (ngModelChange)="toDefault()">
                                <mat-radio-button [value]="true">
                                    Use Default
                                </mat-radio-button>
                                <mat-radio-button [value]="false">
                                    Customize
                                </mat-radio-button>
                                <input [value]="style.sidebarUnderline.color.value"
                                       [style.background]="style.sidebarUnderline.color.value" [cpCancelButton]="true"
                                       [disabled]="style.sidebarUnderline.color.isDefault"
                                       (colorPickerChange)="chooseColor()"
                                       [(colorPicker)]="style.sidebarUnderline.color.value" cpPosition="left"/>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>

                <div class="panel-header preview-header">
                    <h1>Preview</h1>
                </div>

                <ig-row>
                    <ig-col [xs]="12" [md]="8">
                        <div class="preview">
                            <ig-row>
                                <ig-col [xs]="3" [md]="3">
                                    <div class="btn-wrap">
                                        <span style="font-size: 16px;color:gray">EVENTS</span>
                                        <div #sidebarUnderline class="sidebar-underline"></div>

                                        <div class="search">search</div>

                                        <div #defaultbtn class="long-btn default-btn">CLICK FOR MAP VIEW</div>

                                        <!--<ig-row>-->
                                        <!--<ig-col [xs]="6">-->
                                        <!--<div #eventbtn class="long-btn event-btn">EVENT</div>-->
                                        <!--</ig-col>-->

                                        <!--<ig-col [xs]="6">-->
                                        <!--<div #placebtn class="long-btn place-btn">PLACE</div>-->
                                        <!--</ig-col>-->
                                        <!--</ig-row>-->


                                        <div #eventbtn class="long-btn event-btn">FILTER BY CATEGORY</div>
                                        <div #placebtn class="long-btn place-btn">EDITOR'S CHOICE</div>
                                        <div #defaultbtn class="long-btn default-btn">SUBMIT EVENTS</div>

                                    </div>
                                </ig-col>
                                <ig-col [xs]="9" [md]="9">
                                    <ig-row>
                                        <ig-col [xs]="4" [md]="4" *ngFor="let card of cards">
                                            <div #pinnedborder class="pinned-border">
                                                <div>
                                                    <img src="{{defaultImg}}" alt="img">
                                                </div>
                                                <div #eventbtn class="time">
                                                    {{ timeSample }}
                                                </div>
                                                <div class="detail">
                                                    <div class="description"></div>
                                                    <div #detailButton class="view detail-btn">DETAILS</div>
                                                </div>
                                            </div>
                                            <div class="card-tip">Default Calendar Style
                                            </div>
                                        </ig-col>
                                        <ig-col [xs]="4" [md]="4">
                                            <div #pinnedborder class="pinned-border">
                                                <div>
                                                    <img src="{{defaultImg}}" alt="img" style="height: 106px">
                                                </div>
                                                <div #eventbtn class="time">
                                                    {{ timeSample }}
                                                </div>
                                                <div #detailButton class="detail-btn">DETAIL</div>
                                            </div>
                                            <div class="card-tip">Square Calendar Style
                                            </div>
                                        </ig-col>
                                        <ig-col [xs]="4" [md]="4">
                                            <div #pinnedborder class="pinned-border long">
                                                <div>
                                                    <img src="{{defaultImg}}" alt="img" style="height: 79px">
                                                </div>
                                                <div class="flex">
                                                    <div #eventbtn class="time">
                                                        {{ timeSample }}
                                                    </div>
                                                    <div #detailButton class="detail-btn">DETAILS</div>
                                                </div>
                                            </div>
                                            <div class="card-tip">Long Calendar Style
                                            </div>
                                        </ig-col>
                                    </ig-row>
                                </ig-col>
                            </ig-row>
                        </div>
                    </ig-col>
                </ig-row>
                <ig-button (trigger)="saveColor($event)" size="md" [isAsync]="true">Save</ig-button>
            </div>

            <ig-trip-planner-color-settings [style]="style"
                                            (onSave)="saveTPColor($event)"></ig-trip-planner-color-settings>

            <!--            <div class="panel">-->
            <!--                <div class="panel-header">-->
            <!--                    <h1>Trip Planner Color Settings</h1>-->
            <!--                </div>-->

            <!--                <div class="flex">-->
            <!--                    <div>-->
            <!--                        <b>Event related</b>-->
            <!--                        <div class="group">-->
            <!--                            <mat-radio-group class="radio-group"-->
            <!--                                             [(ngModel)]="style.tripPlanner.event.color.isDefault"-->
            <!--                                             (ngModelChange)="toTPDefault()">-->
            <!--                                <mat-radio-button [value]="true">-->
            <!--                                    Use Default-->
            <!--                                </mat-radio-button>-->
            <!--                                <mat-radio-button [value]="false">-->
            <!--                                    Customize-->
            <!--                                </mat-radio-button>-->
            <!--                                <input [value]="style.tripPlanner.event.color.value"-->
            <!--                                       [style.background]="style.tripPlanner.event.color.value"-->
            <!--                                       [cpCancelButton]="true"-->
            <!--                                       [disabled]="style.tripPlanner.event.color.isDefault"-->
            <!--                                       (colorPickerChange)="chooseColor()"-->
            <!--                                       [(colorPicker)]="style.tripPlanner.event.color.value"/>-->
            <!--                            </mat-radio-group>-->
            <!--                        </div>-->
            <!--                    </div>-->

            <!--                    <div>-->
            <!--                        <b>Place related</b>-->
            <!--                        <div class="group">-->
            <!--                            <mat-radio-group class="radio-group"-->
            <!--                                             [(ngModel)]="style.tripPlanner.place.color.isDefault"-->
            <!--                                             (ngModelChange)="toTPDefault()">-->
            <!--                                <mat-radio-button [value]="true">-->
            <!--                                    Use Default-->
            <!--                                </mat-radio-button>-->
            <!--                                <mat-radio-button [value]="false">-->
            <!--                                    Customize-->
            <!--                                </mat-radio-button>-->
            <!--                                <input [value]="style.tripPlanner.place.color.value"-->
            <!--                                       [style.background]="style.tripPlanner.place.color.value"-->
            <!--                                       [cpCancelButton]="true"-->
            <!--                                       [disabled]="style.tripPlanner.place.color.isDefault"-->
            <!--                                       (colorPickerChange)="chooseColor()"-->
            <!--                                       [(colorPicker)]="style.tripPlanner.place.color.value"/>-->
            <!--                            </mat-radio-group>-->
            <!--                        </div>-->
            <!--                    </div>-->

            <!--                    <div>-->
            <!--                        <b>Itinerary related</b>-->
            <!--                        <div class="group">-->
            <!--                            <mat-radio-group class="radio-group"-->
            <!--                                             [(ngModel)]="style.tripPlanner.tour.color.isDefault"-->
            <!--                                             (ngModelChange)="toTPDefault()">-->
            <!--                                <mat-radio-button [value]="true">-->
            <!--                                    Use Default-->
            <!--                                </mat-radio-button>-->
            <!--                                <mat-radio-button [value]="false">-->
            <!--                                    Customize-->
            <!--                                </mat-radio-button>-->
            <!--                                <input [value]="style.tripPlanner.tour.color.value"-->
            <!--                                       [style.background]="style.tripPlanner.tour.color.value"-->
            <!--                                       [cpCancelButton]="true"-->
            <!--                                       [disabled]="style.tripPlanner.tour.color.isDefault"-->
            <!--                                       (colorPickerChange)="chooseColor()"-->
            <!--                                       [(colorPicker)]="style.tripPlanner.tour.color.value"/>-->
            <!--                            </mat-radio-group>-->
            <!--                        </div>-->
            <!--                    </div>-->

            <!--                    <div>-->
            <!--                        <b>My Trip related</b>-->
            <!--                        <div class="group">-->
            <!--                            <mat-radio-group class="radio-group"-->
            <!--                                             [(ngModel)]="style.tripPlanner.trip.color.isDefault"-->
            <!--                                             (ngModelChange)="toTPDefault()">-->
            <!--                                <mat-radio-button [value]="true">-->
            <!--                                    Use Default-->
            <!--                                </mat-radio-button>-->
            <!--                                <mat-radio-button [value]="false">-->
            <!--                                    Customize-->
            <!--                                </mat-radio-button>-->
            <!--                                <input [value]="style.tripPlanner.trip.color.value"-->
            <!--                                       [style.background]="style.tripPlanner.trip.color.value"-->
            <!--                                       [cpCancelButton]="true"-->
            <!--                                       [disabled]="style.tripPlanner.trip.color.isDefault"-->
            <!--                                       (colorPickerChange)="chooseColor()"-->
            <!--                                       [(colorPicker)]="style.tripPlanner.trip.color.value"/>-->
            <!--                            </mat-radio-group>-->
            <!--                        </div>-->
            <!--                    </div>-->

            <!--                    <div>-->
            <!--                        <b>Buttons</b>-->
            <!--                        <div class="group">-->
            <!--                            <mat-radio-group class="radio-group"-->
            <!--                                             [(ngModel)]="style.tripPlanner.buttons.color.isDefault"-->
            <!--                                             (ngModelChange)="toTPDefault()">-->
            <!--                                <mat-radio-button [value]="true">-->
            <!--                                    Use Default-->
            <!--                                </mat-radio-button>-->
            <!--                                <mat-radio-button [value]="false">-->
            <!--                                    Customize-->
            <!--                                </mat-radio-button>-->
            <!--                                <input [value]="style.tripPlanner.buttons.color.value"-->
            <!--                                       [style.background]="style.tripPlanner.buttons.color.value"-->
            <!--                                       [cpCancelButton]="true"-->
            <!--                                       [disabled]="style.tripPlanner.buttons.color.isDefault"-->
            <!--                                       (colorPickerChange)="chooseColor()"-->
            <!--                                       [(colorPicker)]="style.tripPlanner.buttons.color.value"/>-->
            <!--                            </mat-radio-group>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--                <div class="panel-header preview-header tp-preview">-->
            <!--                    <h1>Preview</h1>-->

            <!--                    <div style="background-color: #eef5f9;padding: 24px;">-->
            <!--                        <div class="p-section p-top">-->
            <!--                            <div style="width: 10%;height: 50px;text-align: center;line-height: 50px;color: white"-->
            <!--                                 [style.background]="style.tripPlanner.trip.color.value">Login-->
            <!--                            </div>-->

            <!--                            <div class="p-dates">-->
            <!--                                <div class="p-date"><mat-icon [style.color]="style.tripPlanner.buttons.color.value">date_range</mat-icon></div>-->
            <!--                                <div class="p-date"><mat-icon [style.color]="style.tripPlanner.buttons.color.value">date_range</mat-icon></div>-->
            <!--                            </div>-->
            <!--                        </div>-->

            <!--                        <div class="p-section m-t-3" style="gap: 16px;display: flex">-->
            <!--                            <div style="transition: 300ms linear all" [style.width]="leftPartWidth">-->
            <!--                                <div class="flex" name>-->
            <!--                                    <div [style.background]="style.tripPlanner.event.color.value"-->
            <!--                                         (click)="style.tripPlanner.preview.selected='event'">Events-->
            <!--                                    </div>-->
            <!--                                    <div [style.background]="style.tripPlanner.place.color.value"-->
            <!--                                         (click)="style.tripPlanner.preview.selected='place'">Places-->
            <!--                                    </div>-->
            <!--                                    <div [style.background]="style.tripPlanner.tour.color.value"-->
            <!--                                         (click)="style.tripPlanner.preview.selected='tour'">Itineraries-->
            <!--                                    </div>-->
            <!--                                    <div [style.background]="style.tripPlanner.trip.color.value"-->
            <!--                                         (click)="style.tripPlanner.preview.selected='trip'">My Trips-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div name style="border-top:1px solid white"-->
            <!--                                     [style.background]="style.tripPlanner[style.tripPlanner.preview.selected].color.value">{{style.tripPlanner.preview.selected.toUpperCase()}}</div>-->

            <!--                                <div *ngIf="!isOnTourOrTrip">-->
            <!--                                    <div style="display: flex;flex-direction: row-reverse"><div [style.background]="style.tripPlanner.buttons.color.value" style="position:relative;right: 0; padding: 6px 12px;color:white;margin: 8px 0;font-size: 12px;display: inline-block">NEXT PAGE</div></div>-->
            <!--                                    <div class="cards-wrap">-->
            <!--                                        <div *ngFor="let card of [1,2,3,4,5,6,7,8]" class="p-cards">-->
            <!--                                            <img [src]="defaultImg" alt="img" width="100%">-->
            <!--                                            <div *ngIf="style.tripPlanner.preview.selected==='event'" [style.background]="style.tripPlanner.event.color.value">{{timeSample}}</div>-->
            <!--                                            <div class="flex">-->
            <!--                                                <div [style.background]="style.tripPlanner.place.color.value">Details</div>-->
            <!--                                                <div [style.background]="style.tripPlanner.buttons.color.value">Add to trip</div>-->
            <!--                                            </div>-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div *ngIf="isOnTour">-->
            <!--                                    <img [src]="tourSideImg" alt="img" width="100%" style="max-height: 500px">-->
            <!--                                </div>-->
            <!--                                <div *ngIf="isOnTrip" class="p-trip-left">-->
            <!--                                    <div *ngFor="let card of [1,2]" class="relative m-b-1">-->
            <!--                                        <img [src]="defaultImg" alt="img" width="100%">-->
            <!--                                        <div name class="text-left" [style.background]="style.tripPlanner.buttons.color.value">Trip name</div>-->
            <!--                                        <div class="p-stop" [style.background]="style.tripPlanner.trip.color.value">3 stops</div>-->
            <!--                                    </div>-->

            <!--                                    <div class="flex m-t-1 m-b-3" style="gap: 8px;">-->
            <!--                                        <div name [style.background]="style.tripPlanner.trip.color.value">Create trip</div>-->
            <!--                                        <div name [style.background]="style.tripPlanner.buttons.color.value">Share trip</div>-->
            <!--                                        <div name [style.background]="style.tripPlanner.buttons.color.value">Export trip</div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                            <div style="transition: 300ms linear all" [style.width]="rightPartWidth">-->
            <!--                                <div *ngIf="!isOnTourOrTrip">-->
            <!--                                    <img [src]="tpBG" alt="img" width="100%">-->
            <!--                                    <p style="padding: 12px 24px;text-align: center">Hit the Roads! Explore events and places. Plan your trip with our trip app. Simply-->
            <!--                                        add things to do and see - save, print and share. Need a little inspiration? Check-->
            <!--                                        out our favorite destination experiences by clicking on the "itineraries" button.-->
            <!--                                        Enter your travel dates below and start planning!</p>-->
            <!--                                    <div class="flex start-icons">-->
            <!--                                        <div [style.background]="style.tripPlanner.event.color.value">-->
            <!--                                            <mat-icon>date_range</mat-icon>-->
            <!--                                        </div>-->
            <!--                                        <div [style.background]="style.tripPlanner.place.color.value">-->
            <!--                                            <mat-icon>room</mat-icon>-->
            <!--                                        </div>-->
            <!--                                        <div [style.background]="style.tripPlanner.tour.color.value">-->
            <!--                                            <mat-icon>directions_car</mat-icon>-->
            <!--                                        </div>-->
            <!--                                        <div [style.background]="style.tripPlanner.trip.color.value">-->
            <!--                                            <mat-icon>work</mat-icon>-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                    <div class="p-dates">-->
            <!--                                        <div class="p-date"><mat-icon [style.color]="style.tripPlanner.buttons.color.value">date_range</mat-icon></div>-->
            <!--                                        <div class="p-date"><mat-icon [style.color]="style.tripPlanner.buttons.color.value">date_range</mat-icon></div>-->
            <!--                                        <div class="p-start" [style.background]="style.tripPlanner.buttons.color.value">START</div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div *ngIf="isOnTour" class="p-tour">-->
            <!--                                    <div *ngFor="let card of [1,2,3,4,5,6]">-->
            <!--                                        <img [src]="defaultImg" alt="img" width="100%">-->
            <!--                                        <div name [style.background]="style.tripPlanner.tour.color.value">Itinerary name</div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                                <div *ngIf="isOnTrip" class="relative">-->
            <!--                                    <img [src]="mapImg" alt="img" width="100%" style="max-height: 500px">-->
            <!--                                    <div class="flex" style="justify-content: center">-->
            <!--                                        <div name class="p-gps" [style.background]="style.tripPlanner.place.color.value">GPS Direction</div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </div>-->

            <!--                </div>-->
            <!--            </div>-->
        </mat-tab>
        <mat-tab label="Logo">
            <ng-template mat-tab-label>
                <mat-icon>image</mat-icon>
                Logo
            </ng-template>
            <div class="panel">
                <div class="half-width">
                    <div class="panel-header">
                        <h1>Customize Logo</h1>
                        <p class="panel-header-p">This logo will be added to your CMS dashboard, PDF exports of events,
                            places and itineraries, as well be used as a photo placeholder for events where organizers
                            did
                            not upload an image</p>
                    </div>

                    <mat-radio-group class="custom-edit-item radio-group" [(ngModel)]="logo.isDefault">
                        <mat-radio-button [value]="true">
                            Use default
                        </mat-radio-button>
                        <mat-radio-button [value]="false">
                            Customize
                        </mat-radio-button>
                    </mat-radio-group>

                    <!--<div class="logo-corper" *ngIf="!logo.isDefault">-->
                    <!--<img-cropper [image]="logoData" (onCrop)="logoImageSet('logo')"-->
                    <!--[settings]="cropperSettings"></img-cropper>-->

                    <!--<ng-container>-->
                    <!--<p>Preview:</p>-->
                    <!--<img #logoimage [src]="logoData.image" alt="Please select an image from the above box"-->
                    <!--[width]="cropperSettings.croppedWidth" [height]="cropperSettings.croppedHeight">-->
                    <!--</ng-container>-->
                    <!--</div>-->

                    <ig-image-cropper *ngIf="!logo.isDefault" #logoCropper [imageData]="logoData"
                                      [cropperSettings]="cropperSettings"></ig-image-cropper>

                    <ig-button size="md" (trigger)="saveLogo($event)" [isAsync]="true">save</ig-button>
                </div>

            </div>
        </mat-tab>
        <mat-tab label="Editor's Choice">
            <ng-template mat-tab-label>
                <mat-icon>favorite</mat-icon>
                Editor's Choice
            </ng-template>

            <ig-marketing show="editor"></ig-marketing>
        </mat-tab>
        <mat-tab label="Custom Categories">
            <ng-template mat-tab-label>
                <mat-icon>star</mat-icon>
                Custom Categories
            </ng-template>

            <ig-marketing show="custom"></ig-marketing>

            <div class="panel custom-default-place-category">
                <div class="panel-header">
                    <h1 [class.text-disabled]="!featuresToggle.placeCalendar">Organize & Edit Places Categories</h1>
                    <span>
                        <upgrade-button [show]="!featuresToggle.placeCalendar" [css]="'upgrade-style'"></upgrade-button>
                    </span>
                </div>
                <ig-hub-customize-place-category
                    [disabled]="!featuresToggle.placeCalendar"></ig-hub-customize-place-category>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon>room</mat-icon>
                Location Filters
            </ng-template>

            <ig-location-filters></ig-location-filters>
        </mat-tab>
        <mat-tab label="Promotions">
            <ng-template mat-tab-label>
                <mat-icon>image</mat-icon>
                Promotions
            </ng-template>

            <ig-marketing show="promotion"></ig-marketing>
        </mat-tab>

    </mat-tab-group>

</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/customization/style/style.component.html